import React from 'react';
import PropTypes from 'prop-types';

import FloatBase from './FloatBase';
import { Tooltip } from './floating.styles';

/**
 * @deprecated Use { Tooltip } from `@companycam/slab-web` instead
 *
 * https://slab-web.cocam.co/?path=/docs/tooltip--docs
 */

function CCTooltip({
  children,
  trigger,
  position,
  triggerStyle,
  onClickOutside,
  offset,
}) {
  if (triggerStyle === 'hidden') {
    return null;
  }

  return (
    <FloatBase
      position={position}
      triggerStyle={triggerStyle}
      trigger={trigger}
      onClickOutside={onClickOutside}
      customOffset={offset}
    >
      <Tooltip>{children}</Tooltip>
    </FloatBase>
  );
}

CCTooltip.propTypes = {
  children: PropTypes.any,
  position: PropTypes.oneOf([
    'top',
    'bottom',
    'right',
    'left',
    'bottom-start',
    'bottom-end',
    'top-start',
    'top-end',
    'left-start',
    'left-end',
    'right-start',
    'right-end',
  ]),
  trigger: PropTypes.node,
  triggerStyle: PropTypes.oneOf(['hover', 'click', 'always', 'hidden']),
  onClickOutside: PropTypes.func,
  offset: PropTypes.number,
};

CCTooltip.defaultProps = {
  position: 'top',
  children: null,
  onClickOutside: () => {},
};

export default CCTooltip;
